// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-04e4c3bc]{display:none}.container[data-v-04e4c3bc]{display:flex;height:24px;justify-content:space-between}.container__text[data-v-04e4c3bc],.container__text-right[data-v-04e4c3bc]{font-size:16px;font-weight:400;letter-spacing:-.25px;line-height:24px}.container__text[data-v-04e4c3bc]{color:var(--c-grey-600)}.container__text-right[data-v-04e4c3bc]{color:var(--c-grey-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
